import { render } from "./PictureImg.vue?vue&type=template&id=f0f8eee8&scoped=true&ts=true"
import script from "./PictureImg.vue?vue&type=script&lang=ts"
export * from "./PictureImg.vue?vue&type=script&lang=ts"

import "./PictureImg.vue?vue&type=style&index=0&id=f0f8eee8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0f8eee8"]])

export default __exports__